var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79136 18.3062C9.45907 18.9512 10.5411 18.9512 11.2088 18.3062L17.494 12.2351C18.1617 11.5901 18.1617 10.5449 17.494 9.89994C16.8263 9.25497 15.7442 9.25497 15.0765 9.89994L11.8403 13.0259V1.77818C11.8403 0.79566 11.0166 0 9.99947 0C8.98231 0 8.1586 0.79566 8.1586 1.77818V13.0259L4.9224 9.89994C4.2547 9.25497 3.17264 9.25497 2.50493 9.89994C1.83722 10.5449 1.83722 11.5901 2.50493 12.2351L8.79011 18.3062H8.79136Z",
    fill: "#499953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9828 20.0371H1.01591C0.45429 20.0371 0 20.4771 0 21.0184C0 21.5597 0.455538 21.9997 1.01591 21.9997H18.9828C19.5445 21.9997 19.9988 21.5597 19.9988 21.0184C19.9988 20.4771 19.5432 20.0371 18.9828 20.0371Z",
    fill: "#499953"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.6818c891fbfa3b796efdcd9e3af312f1.svg";
export { ForwardRef as ReactComponent };